export default __webpack_public_path__ + "static/media/back.91c7eefd.png";